"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
function toError(errors) {
    errors = errors || [];
    if (!Array.isArray(errors))
        errors = [{ errorMessage: errors, isWarning: false, propertyName: '' }];
    var isValid = errors.length === 0;
    var title = isValid ? undefined : errors.map(function (x) { return x.errorMessage; }).join('\r\n').trim();
    var className = isValid ? null : (errors.some(function (x) { return !x.isWarning; }) ? 'input-validation-error' : 'input-validation-warning');
    return {
        isValid: isValid,
        title: title,
        className: className,
        allWarnings: !errors.some(function (x) { return !x.isWarning; })
    };
}
exports.toError = toError;
function toErrorProps(classes, title, errors) {
    errors = errors || [];
    if (!Array.isArray(errors))
        errors = [{ errorMessage: errors, isWarning: false, propertyName: '' }];
    var output = toError(errors);
    return {
        "aria-invalid": !output.isValid,
        title: output.isValid ? title : output.title,
        className: classNames(classes, output.className)
    };
}
exports.toErrorProps = toErrorProps;
